import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { syncAllExceptionsAccess } from '../../store/global-settings.actions';
import { filter, Subscription } from 'rxjs';
import { openActionDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { ActionDialogType } from 'src/app/shared/models/enums/action-dialog-type.enum';
import { MultiUsersSearchComponent } from 'src/app/shared/components/multi-users-search/multi-users-search.component';
import { loadAllExceptionsAccess } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.actions';
import { selectAllExceptions } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.selectors';

@Component({
  standalone: false,
  selector: 'app-exception-access-dialog',
  templateUrl: './exception-access-dialog.component.html',
  styleUrls: ['./exception-access-dialog.component.scss'],
})
export class ExceptionAccessDialogComponent implements OnInit, OnDestroy {
  @ViewChild(MultiUsersSearchComponent)
  multiUsersSearch!: MultiUsersSearchComponent;
  private readonly subscription = new Subscription();
  exceptions?: string[];
  private originalExceptions?: string[];
  readonly = true;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<ExceptionAccessDialogComponent>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadAllExceptionsAccess());

    this.subscription.add(
      this.store
        .select(selectAllExceptions)
        .pipe(filter((x) => x != null))
        .subscribe((exceptions) => {
          this.originalExceptions = exceptions!;
          this.exceptions = exceptions!;
          this.multiUsersSearch.setValue(this.exceptions!);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onExceptionsChanged(exceptions: (string | null)[]) {
    this.exceptions = exceptions.filter((x) => x).map((x) => x!);
  }

  closeWindow() {
    this.dialogRef.close();
  }

  edit() {
    this.readonly = false;
  }

  cancel() {
    this.readonly = true;
    this.exceptions = this.originalExceptions;
    this.multiUsersSearch.setValue(this.exceptions!);
  }

  save() {
    this.store.dispatch(
      openActionDialog({
        title: 'confirm saved changes',
        description:
          "Please confirm that you'd like to save these changes. This action may impact all exceptions and their access and permissions.",
        confirmButtonText: 'confirm changes',
        dialogType: ActionDialogType.Confirmation,
        onConfirm: () => {
          this.readonly = true;
          this.store.dispatch(
            syncAllExceptionsAccess({ exceptionsIds: this.exceptions! })
          );
        },
      })
    );
  }
}
